import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import React from 'react';
import { FDStack } from '@facet-wealth/design';
import ExpenseStepHeader
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingSelectRecurringExpenses/ExpenseStepHeader';
import RecurringExpenseGroup
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingRecurringExpenses/RecurringExpenseGroup';
import OnboardingAddItemButton
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/ExpensesDetail/OnboardingAddItemButton';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';
import fr from 'facet-rest';
import MissingInformationConfirmationDialog
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingRecurringExpenses/MissingInformationConfirmationDialog';
import { useSnackbarContext } from 'Context/SnackbarContext';
import RecurringExpenseItemFrequency
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingRecurringExpenses/RecurringExpenseItemFrequency';
import RecurringExpenseItemAmount
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingRecurringExpenses/RecurringExpenseItemAmount';

const ONBOARDING_RECURRING_EXPENSE_AMOUNTS = 'onboardingRecurringExpenseAmounts';

function OnboardingRecurringExpenses() {
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();
  const [showConfirmation, setShowConfirmation] = React.useState(false);
  const {
    setOnboardingStepCollection,
  } = useSurveyContext();
  useScrollTopOnMount();
  const { displayErrorMessage } = useSnackbarContext();
  const recurringExpenseGroups = resource.attr('groups').resources().list();

  let RecurringExpenseItemComponent = RecurringExpenseItemFrequency;
  if (resource.type() === ONBOARDING_RECURRING_EXPENSE_AMOUNTS) {
    RecurringExpenseItemComponent = RecurringExpenseItemAmount;
  }

  const handleAddNewExpense = async (rel) => {
    try {
      const newOnboardingStep = await rel.link('related').get();
      setOnboardingStepCollection(newOnboardingStep);
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to add new expense');
    }
  };

  const handleSubmitFromConfirmation = async () => {
    try {
      const newOnboardingCollection = await onSubmitMetaForm();
      setOnboardingStepCollection(newOnboardingCollection);
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to submit');
    }
  };

  const handleSubmit = async () => {
    try {
      const [tmpResource] = await resource.link('self').get();
      tmpResource.withRelationship(fr.relationships.missingInformationConfirmation.name, () => {
        setShowConfirmation(true);
      }, async () => {
        await handleSubmitFromConfirmation();
      });
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to submit');
    }
  };

  if (!resource) return null;
  return (
    <React.Fragment>
      <FDStack direction={'column'} spacing={4}>
        <ExpenseStepHeader resource={resource} />
        {
          recurringExpenseGroups.map((group) => {
            return <RecurringExpenseGroup resource={group} RecurringExpenseItemComponent={RecurringExpenseItemComponent} key={group.id()} />;
          })
        }
        <OnboardingAddItemButton relationship={resource.relationship(fr.relationships.addItem.name)} onAdd={(e) => handleAddNewExpense(e)} />
        <SurveyStepFooter
          onSubmit={handleSubmit}
          nextButtonLabel={'Continue'}
        />
      </FDStack>
      <MissingInformationConfirmationDialog
        relationship={resource.relationship(fr.relationships.missingInformationConfirmation.name)}
        isOpen={showConfirmation}
        setOpen={setShowConfirmation}
        handleNext={handleSubmitFromConfirmation}
      />
    </React.Fragment>
  );
}

OnboardingRecurringExpenses.propTypes = {
};

OnboardingRecurringExpenses.defaultProps = {
};

export default OnboardingRecurringExpenses;
